<template>
  <!-- Este componente tiene como objetivo subir los documentos requeridos para poder iniciar una maestria
son siete documentos y cada uno cuenta con un estatus y un comentario la tabla para estos documentos es compartida
es modificada tanto por el candidato como el administrador. Solo se admiten archivos con el formato .pdf estos se
guardan en la base de datos y en el servidor para tener un respaldo
los estatus del documento don los siguientes 
1.Por revisar
2.Revisado
3.Aceptado
4.Rechazado
  5.Reenviado-->
  <div>
    <div class="row">
      <div class="col m3 s3"></div>
      <div class="col m6 s6">
        <ul class="collection">
          <li class="collection-item avatar">
            <span class="title">Información prospecto:</span>
            <p v-if="datosP.length != 0">
              Nombre: {{ datosP[0].nombres }} {{ datosP[0].apellidos }}
              <br />
              Correo: {{ datosP[0].correo }}
              <br />
            </p>
            <a href="#!" class="secondary-content">
              <i class="material-icons">grade</i>
            </a>
          </li>
        </ul>
      </div>
      <div class="col m3 s3"></div>
    </div>

    <div class="row">
      <!-- <div class="col s1 m1"></div> -->

      <!-- <div class="col s12 m12"> -->
      <!-- <div class="card-panel teal lighten-5">
          <span
            >Documentos de lectura para el participante, da clic para
            descargar:</span
          >
          <br />
          <a href="./doc/Acuse.pdf" target="_blank">
            Acuse de lectura de los criterios de redacción de anteproyecto
            <i class="material-icons">cloud_download</i>
          </a>
          <br />
          <a href="./doc/CriteriosEvaluacion.pdf" target="_blank">
            Documento de criterios de evaluación
            <i class="material-icons">cloud_download</i>
          </a>
        </div> -->
      <!-- </div> -->
      <div v-if="acuse == 0">
        <p>
          <label>
            <!-- <input name="group1" type="radio" v-model="terms" /> -->
            <input id="terms" type="checkbox" v-model="terms" />
            <!-- <span>He leido los documentos aquí proporcionados</span> -->
            <span
              >Estoy de acuerdo en compartir mi información personal con el
              Instituto Latinoamericano de la Comunicación Educativa (ILCE) para
              dar seguimiento en mi proceso de inscripción a la maestría.</span
            >
          </label>
        </p>
        <button
          class="btn center"
          :disabled="isDisabled"
          @click="actualizarAcuse"
        >
          Acepto
        </button>
      </div>
      <div v-if="acuse == 1">
        <!-- <p>El acuse de enterado ha sido aceptado</p> -->
        <p>
          Ha aceptado el acuerdo de compartir su información personal con el
          Instituto Latinoamericano de la Comunicación Educativa (ILCE) para dar
          seguimiento en su proceso de inscripción a la maestría.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col s1 m1"></div>

      <p>
        <b>Fecha límite para entrega de proyectos: "No disponible"</b>
      </p>
      <div class="col s1 m1"></div>
      <p>
        <b>Para continuar con el proceso debe de subir todos sus documentos</b>
      </p>
      <div class="col s1 m1"></div>

      <p>Porcentaje de documentos cargados: {{ this.porcentaje }}%</p>
      <div class="col s1 m1"></div>

      <div class="progress col m6 s6">
        <div
          class="determinate orange accent-4"
          :style="{ width: porcentaje + '%' }"
        ></div>
      </div>
    </div>
    <table class="responsive-table">
      <tbody>
        <tr>
          <th>Curriculum vitae / Carta de vida</th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_curriculum != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="curriculum"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('curriculum')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_curriculum == 1) ||
                datosP[0].s_curriculum == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_curriculum == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_curriculum == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_curriculum == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_curriculum }}
          </td>
        </tr>
        <tr>
          <th>Acta de Nacimiento</th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_acta_nacimiento != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="acta_nacimiento"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('acta_nacimiento')"
                >subir</a
              >
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_acta_nacimiento == 1) ||
                datosP[0].s_acta_nacimiento == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_acta_nacimiento == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_acta_nacimiento == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_acta_nacimiento == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_acta_nacimiento }}
          </td>
        </tr>
        <tr>
          <th>Identificación Oficial</th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_identificacion != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="identificacion"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('identificacion')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_identificacion == 1) ||
                datosP[0].s_identificacion == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_identificacion == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_identificacion == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_identificacion == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_identificacion }}
          </td>
        </tr>
        <tr>
          <th>CURP o RNP</th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_curp != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="curp"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('curp')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_curp == 1) ||
                datosP[0].s_curp == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_curp == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_curp == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_curp == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_curp }}
          </td>
        </tr>
        <tr>
          <th>Certificado total de Licenciatura</th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_certificado != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="certificado"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('certificado')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_certificado == 1) ||
                datosP[0].s_certificado == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_certificado == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_certificado == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_certificado == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_certificado }}
          </td>
        </tr>
        <tr>
          <th>
            Título profesional
            <br />
            <i style="color: #1e88e5"
              >De no contar con título puede ser un documento oficial que
              autorice la obtención de grado de licenciatura</i
            >
          </th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_titulo != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="titulo"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('titulo')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_titulo == 1) ||
                datosP[0].s_titulo == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_titulo == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_titulo == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_titulo == 4"
            >
              Documento rechazado
            </p>
          </td>

          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_titulo }}
          </td>
        </tr>
        <tr>
          <th>Cédula profesional</th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_cedula != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="cedula"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('cedula')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_cedula == 1) ||
                datosP[0].s_cedula == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_cedula == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_cedula == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_cedula == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_cedula }}
          </td>
        </tr>
        <tr>
          <th>Carta de exposición de motivos</th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_carta != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="carta"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('carta')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_carta == 1) ||
                datosP[0].s_carta == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_carta == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_carta == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_carta == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_carta }}
          </td>
        </tr>

        <tr>
          <th>
            Fotografía digitalizada
            <br />
            <!-- <p>Especificaciones: <br /></p> -->

            <!-- TAMAÑO: Hasta 8 megas.
 
FORMATO: Únicamente en jpg.
 
CARACTERÍSTICAS: A color, con fondo claro y liso (no se permiten fotografías en blanco y negro o sepia ni fondos con textura o paisajes), reciente y nítida (no pixelada, borrosa, manchada, con marcas o defectos).
 
ESPECIFICACIONES: Presentar a la persona de frente con sus rasgos claramente perfilados. La imagen de la persona debe ser proporcional al tamaño de la fotografía (de cabello, cuello y la parte superior de los hombros). -->

            <ul
              style="margin: 2%; color: #1e88e5; text-align: justify"
              type="circle"
            >
              <li><b>TAMAÑO: </b>Hasta 8 megas.</li>
              <li><b>FORMATO:</b> Únicamente en jpg.</li>
              <li>
                <b>CARACTERÍSTICAS:</b> A color, con fondo claro y liso (no se
                permiten fotografías en blanco y negro o sepia ni fondos con
                textura o paisajes), reciente y nítida (no pixelada, borrosa,
                manchada, con marcas o defectos).
              </li>
              <li>
                <b>ESPECIFICACIONES:</b> Presentar a la persona de frente con
                sus rasgos claramente perfilados. La imagen de la persona debe
                ser proporcional al tamaño de la fotografía (de cabello, cuello
                y la parte superior de los hombros).
              </li>
              <!-- <li>4. Ser reciente y nítida.</li>
              <li>
                5. Presentar a la persona de frente con sus rasgos claramente
                perfilados (no pixelados, borrosas, manchadas, con marcas o
                defectos).
              </li>
              <li>
                6. Mostrar la imagen de la persona proporcional al tamaño de la
                fotografía (de cabello, cuello y la parte superior de los
                hombros).
              </li>
              <li>7. Contar con fondo claro (sin textura, ni paisaje).</li> -->
            </ul>
          </th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_foto != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="foto"
                    class="documentos"
                    accept="image/jpeg"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('foto')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_foto == 1) ||
                datosP[0].s_foto == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_foto == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_foto == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_foto == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_foto }}
          </td>
        </tr>

        <!-- <tr>
          <th>Anteproyecto de investigación</th>
          <td v-if="datosP.length != 0">
            <form action="#" v-if="datosP[0].s_anteproyecto != 3">
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    type="file"
                    id="anteproyecto"
                    class="documentos"
                    accept=".pdf"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text" />
                </div>
              </div>
              <a class="btn green" @click="subirArc('anteproyecto')">subir</a>
            </form>
            <p
              class="cyan accent-2"
              v-if="
                (datosP.length != 0 && datosP[0].s_anteproyecto == 1) ||
                datosP[0].s_anteproyecto == 5
              "
            >
              Documento en proceso de validación
            </p>

            <p
              class="white-text orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_anteproyecto == 2"
            >
              Documento revisado cuenta con observaciones
            </p>

            <p
              class="white-text green accent-4"
              v-if="datosP.length != 0 && datosP[0].s_anteproyecto == 3"
            >
              Documento aprobado
            </p>

            <p
              class="white-text deep-orange darken-1"
              v-if="datosP.length != 0 && datosP[0].s_anteproyecto == 4"
            >
              Documento rechazado
            </p>
          </td>
          <td v-if="datosP.length != 0">
            <strong>Comentarios:</strong>
            <br />
            {{ datosP[0].c_anteproyecto }}
          </td>
        </tr> -->
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
import swal from "sweetalert";
export default {
  data() {
    return {
      datosP: [],
      porcentaje: 0,
      terms: false,
      acuse: 0,
    };
  },
  methods: {
    cargaInfo() {
      let datosG = new FormData();
      let total = 0;
      let porcentaje = 0;
      datosG.append("usuario", this.$store.state.usuario);
      datosG.append("contrasena", this.$store.state.contrasena);

      axios
        .post(this.$store.state.url + "candidatos_posgrado.php", datosG)
        .then((res) => {
          // console.log(res.data);
          this.datosP = res.data;
          for (let index = 0; index < this.datosP.length; index++) {
            const element = this.datosP[index];
            for (const elemento in element) {
              const valor = element[elemento];
              if (elemento != "s_anteproyecto") {
                //si se quiere agregar el anteproyecto

                if (elemento.indexOf("s_") == 0) {
                  // console.log(elemento);
                  total++;
                  if (valor >= 1) {
                    porcentaje++;
                  }
                  if (elemento == "s_acuse_lectura" && valor >= 1) {
                    this.acuse = 1;
                  }
                }
              }
            }
            // console.log("porcentaje"+porcentaje+"total"+total);
            porcentaje = (porcentaje * 100) / total;
            porcentaje = Math.round(porcentaje);
            this.porcentaje = porcentaje;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async subirArc(x) {
      let archivo = document.querySelector("#" + x);
      if (archivo.files[0] != undefined) {
        // console.log(archivo.files[0]);
        let datos = new FormData();
        datos.append("usuarios", this.$store.state.usuario);
        datos.append("archivo", archivo.files[0]);
        datos.append("campobd", x);
        datos.append("id_pros", this.datosP[0].id_pros);
        // console.log("uno" + this.datosP[0].id_pros + "dos" + this.datosP[0].id);
        await axios
          .post(this.$store.state.url + "subirarchivo.php", datos)
          .then((res) => {
            console.log(res.data);

            if (res.data == true) {
              swal("", "El archivo se guardo exitosamente", "success");
              this.cargaInfo();
            } else {
              swal("", "Ha ocurrido un error", "error");
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
      if (archivo.files[0] === undefined) {
        swal("", "Elige un archivo para cargar", "error");
      }
    },
    actualizarAcuse() {
      let datos = new FormData();
      datos.append("id_pros", this.datosP[0].id_pros);
      console.log(this.datosP[0].id_pros);

      axios
        .post(this.$store.state.url + "actualizarAcuse.php", datos)
        .then((res) => {
          console.log(res.data);
          if (res.data == true) {
            this.cargaInfo();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  created() {
    this.cargaInfo();
  },
  computed: {
    isDisabled: function () {
      return !this.terms;
    },
  },
};
</script>

<style scoped>
th,
td {
  width: 25%;
}
</style>